<template>
  <div>
    <div class="page_center">
      <div style="height:71px; width:100%"></div>
      <div class="banner-top-wrapper">
        <image-component :path="bannerPath"></image-component>
        <div class="banner-title">
          <p>
            <span class="sub">해피테이블 사용 증진과 다양성을 위한</span>
            <br />
            <span class="main">
              <span class="deepOrange">'해피테이블'</span>매니저 3.5 업데이트
            </span>
          </p>
        </div>
      </div>
      <section class="update-content-wrapper">
        <article class="article-padding">
          <p class="sub-index">내용 1</p>
          <p class="content">
            해피테이블끼리 온라인에서 만나 대전하는<br />
            <span class="deepOrange">해피테이블 멀티게임</span>이 출시됩니다.
          </p>
          <image-component
            path="update3.5/update3.5_image01.png"
          ></image-component>
          <div
            class="flex"
            style="margin-top: 50px; justify-content: space-between; flex-wrap: nowrap;"
          >
            <image-component
              path="update3.5/update3.5_image02.png"
            ></image-component>
            <image-component
              path="update3.5/update3.5_image03.png"
            ></image-component>
            <image-component
              path="update3.5/update3.5_image04.png"
            ></image-component>
          </div>
        </article>
        <article class="article-padding">
          <div class="sub-index">내용 2</div>
          <p class="content">
            안드로이드버전 해피테이블
            <span class="deepOrange">와이파이 설정 지원</span>
          </p>
          <image-component
            path="update3.5/update3.5_image06.png"
          ></image-component>
          <p class="content">
            <span class="medium"
              >위아래 스크롤을 통해 와이파이 설정을 해야했던 기존 버전에서<br /><span
                class="deepOrange"
                >설정을 통해 보다 빠르고 간편하게 와이파이 연결</span
              >을 지원합니다.</span
            >
          </p>
        </article>
      </section>
      <section class="update-content-wrapper card-content">
        <article class="article-padding card">
          <div class="sub-index">내용 3</div>
          <p class="content">
            해피테이블 경쟁 신규게임
            <span class="deepOrange">함께 장기두기</span>
          </p>
          <image-component
            path="update3.5/update3.5_image07.png"
          ></image-component>
          <p class="content">
            <span class="medium"
              >경쟁 콘텐츠인 <span class="deepOrange">'함께 장기두기'</span>가
              추가되었습니다.</span
            >
          </p>
        </article>
      </section>
      <section class="business-content">
        <div class="article-padding content info">
          <p class="title fontExtraBold">문의하기</p>
          <p class="sub">
            3.5 업데이트에 대한 자세한 문의는 해피테이블 카카오 채널로 채팅
            부탁드립니다.
          </p>
          <a
            class="kakao-link"
            href="http://pf.kakao.com/_xjYRxab"
            target="_blank"
          >
            <div class="kakao" style="display:flex">
              <div class="kakao-img-wrapper">
                <img
                  src="@/assets/source/images/m_ic_sns_kakao.svg"
                  alt="go to kakao"
                />
              </div>
              <p class="title">카카오 채널 문의</p>
            </div>
          </a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import imageComponent from "@/components/imageComponent.vue";
export default {
  components: {imageComponent},
  data() {
    return {
      isJpg: false,
      bannerPath: "update3.5/update3.5_top.png",
    };
  },
};
</script>
<style>
.deepOrange {
  color: #ff5230;
}
.orange {
  color: #ef7d52;
}
</style>
<style scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 60px 30px;
}
.flex > * {
  flex: 1 1 auto;
}

.banner-top-wrapper {
  position: relative;
}
.banner-top-wrapper >>> img {
  display: block;
}

.banner-title {
  position: absolute;
  top: calc(100vw / 20);
  left: 50%;
  transform: translate(-50%, 0%);
  width: 100%;
}
.banner-title .sub {
  text-align: center;
  font: normal normal 500 36px/61px paybooc;
  letter-spacing: 0px;
  color: #737373;
  display: block;
  /* margin-bottom: 30px; */
  margin-bottom: calc(100vw / 64);
  font-size: calc(100vw / 53.33);
  line-height: calc(100vw / 31.47);
}
.banner-title .main {
  font: normal normal 800 80px/68px paybooc;
  letter-spacing: -4px;
  font-size: calc(100vw / 24);
  line-height: calc(100vw / 28.23);
}

.deepOrange {
  color: #ff5230;
}
.sub-index {
  display: inline-block;
  background-color: #ef7d52;
  border-radius: 33px;
  padding: 19px 33px;
  font: normal normal 800 24px/28px paybooc;
  color: #ffffff;
}
.update-content-wrapper {
  padding: 100px 0;
}
.update-content-wrapper .content {
  font: normal normal bold 36px/60px paybooc;
  padding: 40px 0 60px;
  word-break: keep-all;
}
.update-content-wrapper >>> img {
  display: block;
}
.update-content-wrapper .content .medium {
  /* font: normal normal 500 30px/60px paybooc; */
  font-size: smaller;
  word-break: keep-all;
}
.update-content-wrapper .content .small {
  font: normal normal 500 20px/60px paybooc;
  color: #929292;
}
.update-content-wrapper .icon {
  display: flex;
  justify-content: center;
  gap: 40px;
  align-items: center;
  padding-bottom: 40px;
}
.update-content-wrapper .old {
  display: inline-block;
  padding: 35px 96px;
  border-radius: 44px;
  box-shadow: 0px 0px 20px #d2d2d2;
  font: normal normal 800 28px/35px paybooc;
  word-break: keep-all;
  color: #7d7d7d;
}
.update-content-wrapper .new {
  display: inline-block;
  padding: 35px 96px;
  border-radius: 44px;
  box-shadow: 0px 0px 20px #ce3f09;
  word-break: keep-all;
  font: normal normal 800 28px/35px paybooc;
  color: #ff5230;
}
.card {
  padding: 3rem 0;
}
.card-content {
  background: #f6efe8 0% 0% no-repeat padding-box;
}
.card-content .info-content {
  padding: 21px 40px 6px;
  width: 45%;
  text-align: left;
}
.card-content .sub-content {
  font: normal normal 500 20px/39px paybooc;
  word-break: keep-all;
}
.card-content .title {
  font: normal normal 800 36px paybooc;
  padding: 20px 0 40px;
  word-break: keep-all;
}
.update-content-wrapper .info-block {
  display: flex;
  align-items: center;
  padding: 73px 0px 73px 40px;
  box-shadow: 0px 3px 6px #5e331529;
  margin-bottom: 3rem;
  background-color: #ffff;
}

.update-content-wrapper article {
  padding: 55px 0;
}
.article-padding {
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.icon-arrow {
  display: inline-block;
}
.icon-arrow >>> img {
  display: block;
}

/* 카카오톡 문의 */
.business-content {
  padding: 100px 0;
}
.business-content .sub {
  padding: 2.5rem 0;
  word-break: keep-all;
  font: normal normal 500 18px/38px paybooc;
  color: rgba(90, 90, 90, 1);
}
.business-content .title {
  font: normal normal 800 40px/60px paybooc;
}
.kakao-img-wrapper {
  width: 54px;
  height: 54px;
}
.kakao-img-wrapper img {
  display: block;
  width: 100%;
}
.kakao {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 524px;
  border: 2px solid #ef7d52;
  border-radius: 62px;
  margin: 0 auto;
  padding: 2rem 0;
}
.kakao .title {
  color: #d65422;
  font-size: 34px;
  margin-left: 2rem;
}
.kakao-link {
  text-decoration: none;
}

@media (max-width: 767px) {
  .banner-title {
    font-size: 1rem;
  }
  .banner-title .main {
    letter-spacing: 0;
  }
  .update-content-wrapper .content {
    font: normal normal 500 30px/54px paybooc;
    /* padding: 40px 0 60px; */
  }

  .update-content-wrapper .old {
    padding: 30px 50px;
    font: normal normal 800 25px/30px paybooc;
  }

  .update-content-wrapper .new {
    padding: 30px 50px;
    font: normal normal 800 25px/30px paybooc;
  }

  .update-content-wrapper .info-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 73px 40px 73px 40px;
    box-shadow: 0px 3px 6px #5e331529;
    margin-bottom: 3rem;
    background-color: #ffff;
  }
  .card-content .info-content {
    padding: 21px 40px 6px;
    width: 100%;
    text-align: center;
  }
  .card-content .sub-content {
    text-align: center;
  }
  .update-content-wrapper article {
    padding: 35px 10% !important;
  }
  .update-content-wrapper {
    padding: 50px 0;
  }
  .kakao .title {
    font-size: 25px;
    margin-left: 1rem;
  }
}

@media (max-width: 550px) {
  .update-content-wrapper .content {
    font: normal normal 500 20px/35px paybooc;
    padding: 30px 0 40px;
  }
  .update-content-wrapper .content .small {
    font: normal normal 500 15px/25px paybooc;
    color: #929292;
  }
  .update-content-wrapper .icon {
    display: flex;
    justify-content: center;
    gap: 20px;
    align-items: center;
    padding-bottom: 40px;
  }
  .icon span {
    padding: 20px 20px !important;
    font: normal normal 800 18px/24px paybooc !important;
  }
  .update-content-wrapper .info-block {
    padding: 40px 20px;
  }
  .card-content .title {
    font: normal normal 800 30px paybooc;
    padding: 20px 0 30px;
  }
  .sub-index {
    padding: 15px 30px;
    font: normal normal 800 20px/28px paybooc;
  }
  .card-content .sub-content {
    font: normal normal 500 18px/35px paybooc;
    word-break: keep-all;
  }
  .business-content {
    padding: 50px 0;
  }
  .card .info-block:last-child {
    margin-bottom: 0;
  }
}
</style>
